import "regenerator-runtime/runtime";

let _configJson;

function _configUrl() {
  const location = window.location.href;
  const qualifUrl = 'https://qualif.coursesu.com/';
  const prodUrl = 'https://www.coursesu.com/';
  const qualifBucketPath = 'https://storage.googleapis.com/assets.miam.tech/coursesu/config/qualif/config.json';
  const prodBucketPath = 'https://storage.googleapis.com/assets.miam.tech/coursesu/config/prod/config.json';
  if (location.includes(qualifUrl)) {
    return qualifBucketPath;
  } else if (location.includes(prodUrl)) {
    return prodBucketPath;
  } else {
    // console.debug("Location not found, can't choose right config, using prod one");
    return prodBucketPath;
  }
}

function _retrieveConfigJson() {
  return new Promise(resolve => {
    const url = _configUrl();
    let xhr = new XMLHttpRequest();
    xhr.open('GET', url);
    xhr.onload = () => {
      _configJson = JSON.parse(xhr.responseText);
      resolve();
    };
    xhr.onerror = () => {
      _configJson = _defaultJson();
      resolve();
    };
    xhr.send();
  });
}

function _defaultJson() {
  return {
    'available_stores': [],
    'available_shelves': [],
    'available_searches': []
  };
}

async function _retrieveConfigJsonIfNecessary() {
  if (_configJson == undefined) {
    await _retrieveConfigJson();
  }
}

export async function getAvailableStores() {
  await _retrieveConfigJsonIfNecessary();
  return _configJson['available_stores']
}
export async function getAvailableShelves() {
  await _retrieveConfigJsonIfNecessary();
  return _configJson['available_shelves']
}
export async function getAvailableSearches() {
  await _retrieveConfigJsonIfNecessary();
  return _configJson['available_searches']
}
export async function getAbCssUrl() {
  await _retrieveConfigJsonIfNecessary();
  return _configJson['ab']
}
export async function getPlannerEntryAbVariants() {
  await _retrieveConfigJsonIfNecessary();
  return _configJson['planner_entry_ab']
}